// Seeded PRNG using mulberry32. Reproducible runs for testing + future seed-sharing.

export class RNG {
  private state: number;

  constructor(seed: number) {
    // Non-zero seed required.
    this.state = seed >>> 0 || 1;
  }

  // Returns a float in [0, 1).
  next(): number {
    let t = (this.state = (this.state + 0x6d2b79f5) >>> 0);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  // Integer in [min, max] inclusive.
  int(min: number, max: number): number {
    return Math.floor(this.next() * (max - min + 1)) + min;
  }

  // Random element from an array.
  pick<T>(array: readonly T[]): T {
    return array[this.int(0, array.length - 1)];
  }

  // True with probability p (0..1).
  chance(p: number): boolean {
    return this.next() < p;
  }

  // Shuffle in-place, return the array.
  shuffle<T>(array: T[]): T[] {
    for (let i = array.length - 1; i > 0; i--) {
      const j = this.int(0, i);
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }
}

export const randomSeed = (): number =>
  Math.floor(Math.random() * 0xffffffff) >>> 0;
